import { render, staticRenderFns } from "./AvatarImageUploadSimple.vue?vue&type=template&id=3aabd32e&"
import script from "./AvatarImageUploadSimple.vue?vue&type=script&lang=js&"
export * from "./AvatarImageUploadSimple.vue?vue&type=script&lang=js&"
import style0 from "./AvatarImageUploadSimple.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports